module.exports = __webpack_public_path__ + "img/gh-31501____-7.prt.5d5869e9.jpg";